<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null && user_name != null">
            <div class="modal fade iviteTeam" id="iviteTeam" tabindex="-1" role="dialog" aria-labelledby="inviteTeam" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-0 digital-welcome align-center">
                            <div class="digital-welcome-content">
                                <span class="name mb-3"> Hello {{user_name}}, </span>
                                <h2> Welcome </h2>
                                <span class="title"> to Finja Business </span>
                                <span class="text-"> Your work life just got better! </span>
                                <p> Apply for leaves, avail advance against salary, keep a track of your attendance and so much more, all through a one stop digital platform. </p>

                                <h3> Follow 4 simple steps to join instantly:  </h3>
                                <ul class="intruction-list">
                                    <li class="instruction-item"> <em class="number">1</em> - Click on the link <router-link to="#"> {{url}} </router-link> </li>
                                    <li class="instruction-item"> <em class="number">2</em> - Enter your email address or phone number </li>
                                    <li class="instruction-item"> <em class="number">3</em> - You will receive a one-time password via SMS or email </li>
                                    <li class="instruction-item"> <em class="number">4</em> - Enter your password to activate your employee profile </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <form id="employeeForm" v-if="crud_employee" @submit.prevent="welcomeEmployee">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">5</span>
                            Time Off
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="top-text welcome-card mb-5 align-center">
                                    <h2 class="mb-3"> Give {{user_name}} a warm welcome! </h2>
                                    <div class="form-group mb-2">
                                        <label class="check-holder mb-3">
                                            Welcome {{user_name}} to your team with a digital card
                                            <input type="checkbox" v-model="form.send_email">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <a href="javascript:void(0)" class="btn btn-primary" data-toggle="modal" data-target=".iviteTeam"> Preview Card </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    send_email: false,
                    id : this.$route.params.id
                }),
                user_name: null,
                url: window.location.origin,
                crud_employee: null
            }
        },
        methods: {
            welcomeEmployee() {
                this.$Progress.start();
                this.form.post('/api/addEmployeeWelcome/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Your employee successfully added');
                        this.$router.push('/employees');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getWelcomeScreenData(){
                this.$Progress.start();
                axios.get('/api/employeeWelcomeScreenData/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            var name = res.data.user.name.split(' ');
                            this.user_name = name[0];
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.$router.push('/addEmployeePersonalDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 1){
                                this.$router.push('/addEmployeeBasicDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 2){
                                this.$router.push('/addEmployeeTaxDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 3){
                                this.$router.push('/addEmployeePaymentDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 4){
                                this.$router.push('/addEmployeeTimeoff/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 5){
                                this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 6){
                                this.getWelcomeScreenData();
                            }
                        }
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    this.getEmployeeData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
